import React from 'react';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import './ContactPage.css';

const CONTACT_CARDS = [
  {
    icon: <WAContactIcon />,
    title: 'Chat with Us',
    value: 'vtdastrology.com/chat',
    action: '/chat',
    cta: 'Start Chat',
    note: 'Fastest response — usually within 30 minutes during business hours',
    primary: true,
  },
  {
    icon: <IGContactIcon />,
    title: 'Instagram',
    value: '@vtd.astrology',
    action: 'https://www.instagram.com/vtd.astrology?igsh=NHZxd3p1MmRoMncz',
    cta: 'Follow Us',
    note: 'DMs open for enquiries and booking',
  },
  {
    icon: <FBContactIcon />,
    title: 'Facebook',
    value: 'VTD Astrology',
    action: 'https://www.facebook.com/share/1EH2UqAzWm/',
    cta: 'Follow Page',
    note: 'Updates, client stories and astrology content',
  },
];

const SERVICE_LINKS = [
  { label: 'Past Prediction' },
  { label: 'Future Consultation' },
  { label: 'Tarot Reading' },
  { label: 'Palmistry Reading' },
  { label: 'Numerology Reading' },
  { label: 'Online Vastu' },
  { label: "Remedies by Tilak" },
];

const ContactPage = () => (
  <div className="contact-page">
    <Navbar />
    <main>
      {/* Hero */}
      <section className="contact-hero">
        <div className="contact-hero__inner">
          <p className="section-eyebrow">Get in Touch</p>
          <h1 className="contact-hero__title">Contact Us</h1>
          <p className="contact-hero__sub">
            We are available Monday to Saturday, 9AM–8PM IST.
            Our chat is the fastest way to reach us.
          </p>
          <div className="gold-divider" style={{ maxWidth: 200, margin: '1.5rem auto 0' }} />
        </div>
      </section>

      {/* Contact cards */}
      <section className="contact-cards-section">
        <div className="contact-cards-inner">
          {CONTACT_CARDS.map((c) => (
            <div key={c.title} className={`contact-card${c.primary ? ' contact-card--primary' : ''}`}>
              <div className="contact-card__icon">{c.icon}</div>
              <h3 className="contact-card__title">{c.title}</h3>
              <p className="contact-card__value">{c.value}</p>
              <p className="contact-card__note">{c.note}</p>
              <a href={c.action} className="contact-card__btn"
                {...(c.action.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                {c.cta} →
              </a>
            </div>
          ))}
        </div>
      </section>

      {/* Service enquiry shortcuts */}
      <section className="contact-services">
        <div className="contact-services__inner">
          <h2 className="contact-services__title">Quick Enquiry by Service</h2>
          <p className="contact-services__sub">
            Tap a service to start a chat with our team
          </p>
          <div className="contact-service-grid">
            {SERVICE_LINKS.map((s) => (
              <a key={s.label} href="/chat" className="contact-service-btn">
                {s.label}
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Business info */}
      <section className="contact-info">
        <div className="contact-info__inner">
          <div className="contact-info__card">
            <h3>Business Hours</h3>
            <p>Monday – Saturday<br /><strong>9:00 AM – 8:00 PM IST</strong></p>
          </div>
          <div className="contact-info__card">
            <h3>Languages</h3>
            <p>Consultations in<br /><strong>Telugu, Hindi &amp; English</strong></p>
          </div>
          <div className="contact-info__card">
            <h3>Response Time</h3>
            <p>Chat messages answered<br /><strong>within 30 minutes</strong> during business hours</p>
          </div>
        </div>
      </section>
    </main>
    <Footer />
  </div>
);

function WAContactIcon() {
  return (
    <svg viewBox="0 0 40 40" width="36" height="36" fill="#25D366" aria-hidden="true">
      <path d="M29 23.4c-.5-.25-2.9-1.44-3.36-1.6-.46-.17-.8-.25-1.13.25-.34.5-1.28 1.6-1.57 1.93-.29.33-.58.37-1.07.12-.5-.25-2.1-.77-3.98-2.46-1.47-1.31-2.46-2.93-2.75-3.43-.29-.5-.03-.77.22-1.01.22-.22.5-.58.74-.87.25-.29.33-.5.5-.83.17-.33.08-.62-.04-.87-.12-.25-1.12-2.68-1.53-3.67-.4-.96-.81-.83-1.12-.85-.29-.01-.62-.02-.95-.02-.33 0-.87.12-1.32.62-.46.5-1.73 1.69-1.73 4.12 0 2.43 1.77 4.78 2.02 5.12.25.33 3.49 5.33 8.46 7.47 1.18.51 2.1.82 2.82 1.04 1.18.38 2.26.33 3.11.2.95-.14 2.93-1.2 3.34-2.35.42-1.15.42-2.14.29-2.35-.12-.2-.46-.32-.96-.57z"/>
      <path d="M20.08 2.67C10.42 2.67 2.58 10.5 2.58 20.17c0 3.1.84 6 2.3 8.47L2.5 37.33l9.03-2.36a17.42 17.42 0 008.55 2.17c9.67 0 17.5-7.83 17.5-17.5 0-9.67-7.83-17.5-17.5-17.5v.03zm0 32c-2.7 0-5.26-.74-7.45-2.03l-.54-.32-5.55 1.46 1.48-5.4-.35-.56a14.49 14.49 0 01-2.23-7.78C5.44 11.6 12.1 4.95 20.08 4.95c7.97 0 14.44 6.47 14.44 14.44 0 7.97-6.47 14.44-14.44 14.44v-.17z" opacity="0.7"/>
    </svg>
  );
}

function IGContactIcon() {
  return (
    <svg viewBox="0 0 40 40" width="36" height="36" fill="none" stroke="#E1306C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="8" y="8" width="24" height="24" rx="7"/>
      <circle cx="20" cy="20" r="6"/>
      <circle cx="27.5" cy="12.5" r="1" fill="#E1306C" stroke="none"/>
    </svg>
  );
}

function FBContactIcon() {
  return (
    <svg viewBox="0 0 40 40" width="36" height="36" fill="#1877F2" aria-hidden="true">
      <path d="M38 20c0-9.94-8.06-18-18-18S2 10.06 2 20c0 8.99 6.58 16.44 15.19 17.78V25.19h-4.57V20h4.57v-3.97c0-4.51 2.69-7 6.8-7 1.97 0 4.03.35 4.03.35v4.43h-2.27c-2.24 0-2.93 1.39-2.93 2.81V20h4.99l-.8 5.19h-4.19v12.59C31.42 36.44 38 28.99 38 20z"/>
    </svg>
  );
}

export default ContactPage;
